<template>
  <div class="subscribe">
    <span @click="show()" class="link" v-html="label" />
    <Modal v-if="showModal" @close="hide()">
      <h3 slot="header" v-html="header" />
    </Modal>
  </div>
</template>

<script>
import Modal from '../Modal.vue'

export default {
  props: [
    'label',
    'header'
  ],

  data () {
    return {
      showModal: false
    }
  },

  components: {
    Modal
  },

  methods: {
    hide () {
      this.showModal = false
    },

    show () {
      this.showModal = true
    }
  }
}

</script>